import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useSelector, useDispatch } from "react-redux";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorContainer from "../../../Components/ErrorContainer";
import ModelContainer from "../../../Components/ModelContainer";
import { actions } from "../../../../Redux";
const TableMaster = (params) => {
  const [formType, setFormType] = useState("add");
  const showForm = useSelector(
    (state) => state?.settingReducer.table_master_form_state
  );
  const setShowForm = (formState) =>
    dispatch(
      actions?.setFormState({ formName: "table_master_form_state", formState })
    );

  const [tableMasterTablesArr, setTableMasterTables] = useState(null);
  const [tableMasterHistoryArr, setTableMasterHistoryArr] = useState(null);

  const dispatch = useDispatch();
  const tableMasterData = useSelector(
    (state) => state?.settingReducer?.table_master_data
  );
  const tableMasterTables = useSelector(
    (state) => state?.settingReducer?.table_master_data?.tableMaster
  );
  const tableMasterHistory = useSelector(
    (state) => state?.settingReducer?.table_master_data?.posTableMasterHistory
  );
  const tableMasterFormData = useSelector(
    (state) => state?.settingReducer?.table_master_form_data
  );
  const tableMasterEditFormData = useSelector(
    (state) => state?.settingReducer?.table_master_edit_form_data
  );
  useEffect(() => {
    dispatch(actions.getTableMasterData());
    dispatch(actions.getTableMasterFormData());
  }, []);

  useEffect(() => {
    setTableMasterTables(tableMasterTables);
  }, [tableMasterTables]);

  function handleTableDetailSearch(val) {
    const filteredArr = tableMasterTables?.filter((el) =>
      el.table_number.startsWith(val)
    );
    setTableMasterTables(filteredArr);
  }

  useEffect(() => {
    setTableMasterHistoryArr(tableMasterHistory);
  }, [tableMasterHistory]);

  function handleTableHistorySearch(val) {
    const filteredArr = tableMasterHistory?.filter((el) =>
      el?.field?.startsWith(val)
    );
    setTableMasterHistoryArr(filteredArr);
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        {!showForm && (
          <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
            <div className="container px-0">
              <div className="row mx-0">
                <div className="container px-0">
                  <div className="shadowclass">
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert"> Table Details </h4>
                    </div>{" "}
                    <div className="row justify-content-between align-items-center w-100 mx-0">
                      <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div className="search-box mt-0">
                          <form>
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                              onChange={(e) =>
                                handleTableDetailSearch(e.target.value)
                              }
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          setFormType("add");
                          setShowForm(true);
                        }}
                        class="col-sm-7 col-12 align-right px-0"
                      >
                        <p class="btn green-btn-revert add-plus mx-0">
                          <i class="i-icon"> </i> Add Table
                        </p>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="checklist-table remove-space inventory_table">
                        <thead>
                          <tr>
                            <th class="header">
                              <a href="">Table ID </a>
                            </th>
                            <th class="header">
                              <a href="">Table Name</a>
                            </th>
                            <th width="" class="header">
                              <a href="">Status</a>
                            </th>
                            <th class="header">Default Covers</th>
                            <th class="action-td">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableMasterTablesArr?.map((el) => (
                            <tr>
                              <td>{el.table_id}</td>
                              <td>{el.table_number}</td>
                              <td>{el.table_status}</td>
                              <td>{el.maximum_seat}</td>
                              <td class="action-td">
                                {" "}
                                <p
                                  onClick={() => {
                                    setFormType("edit");
                                    dispatch(
                                      actions.getEditTableMasterFormData(el.id)
                                    );
                                    setShowForm(true);
                                  }}
                                  className="circle_icon edit_tooltip"
                                >
                                  <i class="iconSprites edit-icon"></i>{" "}
                                </p>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="clearfix"></div>

              <div className="row mx-0">
                <div className="container px-0">
                  <div className="shadowclass">
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert"> History </h4>
                    </div>{" "}
                    <div className="row justify-content-between align-items-center w-100 mx-0">
                      <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div className="search-box mt-0">
                          <form>
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                              onChange={(e) =>
                                handleTableHistorySearch(e.target.value)
                              }
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="checklist-table remove-space inventory_table">
                        <thead>
                          <tr>
                            <th class="header">
                              <a href="">Start </a>
                            </th>
                            <th class="header">
                              <a href="">End</a>
                            </th>
                            <th width="" class="header">
                              <a href="">Field</a>
                            </th>
                            <th class="header">Value</th>
                            <th class="header">Replacement Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableMasterHistoryArr?.map((el) => (
                            <tr>
                              <td>{el.start}</td>
                              <td>{el.end}</td>
                              <td>{el.field}</td>
                              <td>{el.value}</td>
                              <td>{el.replacement_value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Add Table form */}
        {showForm && (
          <TableForm
            tableMasterFormData={tableMasterFormData}
            formType={formType}
            tableMasterEditFormData={tableMasterEditFormData}
            setShowForm={setShowForm}
          />
        )}
        {/* /Add Table form */}
      </div>
    </UserInterface>
  );
};
const TableForm = ({
  tableMasterFormData,
  tableMasterEditFormData,
  formType,
  setShowForm,
}) => {
  console.log(tableMasterFormData, "kkkkkkkk");
  const dispatch = useDispatch();
  const [newRoomLabel, setNewRoomLabel] = useState("");
  const [addRoomModal, setaddRoomModal] = useState(false);
  useEffect(() => {
    if (newRoomLabel !== "") {
      const newRoomValue = tableMasterFormData.rooms.find(
        (el) => el.label === newRoomLabel
      ).value;
      setTableFormField("room_id", newRoomValue);
    }
  }, [tableMasterFormData]);
  const tableAddDefaultState = {
    // table_id: "",
    table_number: "",
    table_status: "",
    maximum_seat: "",
    room_id: "",
    table_type_id: "",
  };
  const tableEditDefaultState = {
    // table_id: "",
    table_number: tableMasterEditFormData?.table_number,
    table_status: tableMasterEditFormData?.table_status,
    maximum_seat: tableMasterEditFormData?.maximum_seat,
    room_id: tableMasterEditFormData?.room_id,
    table_type_id: tableMasterEditFormData?.table_type_id,
  };
  const tableFormSchema = yup.object({
    // table_id: yup.string().required(),
    table_number: yup.string().required(),
    table_status: yup.string().required(),
    maximum_seat: yup.string().required(),
    room_id: yup.string().required(),
    table_type_id: yup.string().required(),
  });

  const {
    register: tableRegister,
    formState: { errors: tableFormErrors },
    handleSubmit: tableFormSubmit,
    reset: tableFormReset,
    setValue: setTableFormField,
  } = useForm({
    resolver: yupResolver(tableFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      formType === "add" ? tableAddDefaultState : tableEditDefaultState,
  });

  useEffect(() => {
    if (formType === "edit") tableFormReset(tableEditDefaultState);
    else tableFormReset(tableAddDefaultState);
  }, [formType, tableMasterEditFormData]);

  function submitData(data) {
    console.log(data, "pppppppppp");

    if (formType === "add") {
      dispatch(
        actions.postAddTableMasterFormData({
          ...data,
          table_id: tableMasterFormData.table_id,
        })
      );
    } else {
      dispatch(
        actions.postEditTableMasterFormData({
          ...data,
          table_id: tableMasterEditFormData.table_id,
          id: tableMasterEditFormData.id,
        })
      );
    }
  }
  return (
    <>
      <form onSubmit={tableFormSubmit(submitData)}>
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass my-4">
              <div class="row mx-0">
                <h4 class="event-alert">Table Details </h4>
                <div class="col-md-6">
                  <ul class="ingredient-info edit-shift">
                    <li>
                      <label class="">Table ID </label>
                      <div class="input-group mb10">
                        {formType === "add"
                          ? tableMasterFormData?.table_id
                          : tableMasterEditFormData?.table_id}
                      </div>
                    </li>
                    <li>
                      <label class="required">Table Name</label>
                      <div class="input-group mb-2">
                        <input
                          {...tableRegister("table_number")}
                          type={"text"}
                          className="form-control"
                        ></input>
                        <ErrorContainer
                          errors={tableFormErrors}
                          name="table_number"
                        />
                      </div>
                    </li>
                    <li>
                      <label class="required">Table Status</label>
                      <div class="input-group select-div mb-2">
                        <select {...tableRegister("table_status")}>
                          <option value="">Select</option>
                          {tableMasterFormData?.stationStatus?.map((el) => (
                            <option value={el.value}>{el.label}</option>
                          ))}
                        </select>{" "}
                        <ErrorContainer
                          errors={tableFormErrors}
                          name="table_status"
                        />
                      </div>
                    </li>
                    <li>
                      <label class="required">Default Covers</label>
                      <div class="input-group select-div mb-2">
                        <select {...tableRegister("maximum_seat")}>
                          <option value="">Select</option>
                          {tableMasterFormData?.seats?.map((el) => (
                            <option value={el.value}>{el.label}</option>
                          ))}
                        </select>{" "}
                        <ErrorContainer
                          errors={tableFormErrors}
                          name="maximum_seat"
                        />
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="col-md-6">
                  <ul class="ingredient-info edit-shift">
                    <li>
                      <label class="required">Room Name</label>
                      <div class="input-group select-div mb10 ">
                        <select
                          {...tableRegister("room_id")}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "new") setaddRoomModal(true);
                          }}
                        >
                          <option value="">Select</option>
                          {tableMasterFormData?.rooms?.map((el) => (
                            <option value={el.value}>{el.label}</option>
                          ))}
                        </select>{" "}
                        <ErrorContainer
                          errors={tableFormErrors}
                          name="room_id"
                        />
                      </div>
                    </li>
                    <li>
                      <label class="required">Table Type</label>
                      <div class="input-group select-div">
                        <select {...tableRegister("table_type_id")}>
                          <option value="">Select</option>
                          {tableMasterFormData?.table_type?.map((el) => (
                            <option value={el.value}>{el.label}</option>
                          ))}
                        </select>{" "}
                        <ErrorContainer
                          errors={tableFormErrors}
                          name="table_type_id"
                        />
                      </div>
                    </li>

                    <li>
                      <label></label>
                      <div class="show_image">
                        <img src="http://uat.gogmgo.com/img/rectangualr_2_seater.png" />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="btn-sec-row clearfix">
              <input
                onClick={() => {
                  setShowForm(false);
                }}
                class="btn cancel"
                type="button"
                value="Cancel"
                id="cancel"
              />
              <input
                class="btn green-btn-revert"
                type="submit"
                value="Push Updates"
                id="saveTemplate"
              />
              <input
                class="btn green-btn-revert"
                type="submit"
                value="Save Changes"
                id="submitBut"
              />
            </div>
          </div>
        </div>
      </form>
      <AddRoomModal
        addRoomModal={addRoomModal}
        setaddRoomModal={setaddRoomModal}
        tableMasterFormData={tableMasterFormData}
        setNewRoomLabel={setNewRoomLabel}
      />
    </>
  );
};

const AddRoomModal = ({ addRoomModal, setaddRoomModal, setNewRoomLabel }) => {
  const dispatch = useDispatch();
  const defaultAddRoomFormSchema = yup.object({
    room_name: yup.string().required(),
  });
  const defaultAddRoomState = {
    room_name: "",
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(defaultAddRoomFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultAddRoomState,
  });

  function submitData(data) {
    setNewRoomLabel(data?.room_name);
    setaddRoomModal(false);
    dispatch(actions.postAddRoomInForm(data));
  }
  return (
    <ModelContainer
      title="Add Room"
      open={addRoomModal}
      closeModal={() => setaddRoomModal(false)}
      submitModal={handleSubmit(submitData)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            <li>
              <label className="required"> Add Room </label>
              <div className="input-wrap ">
                <input
                  {...register("room_name")}
                  class="required"
                  placeholder="Room Name"
                  type="text"
                />
                <ErrorContainer errors={errors} name="room_name" />
              </div>
            </li>
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};

export default TableMaster;
